import Api from './Api'

export default {
    get() {
        return Api().post(`categories`);
    },
    getOne(slug) {
        return Api().get(`categories/${slug}`);
    }
}